import { apiRoutes } from "@constants/api-routes";
import { POLICY_COMPONENT_ID_PATTERN } from "@constants/url-parameter-patterns";
import { RequestTypes } from "@enums/request-types";
import { PolicyComponent } from "@idw-types/data/reference-data/generic/policy-component";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithBody } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";

type UpdatePolicyComponentRequestResponse = {
    transferObject: PolicyComponent;
};

export const updatePolicyComponentRequest = async (
    body: PolicyComponent
): Promise<GenericNetworkResponse<UpdatePolicyComponentRequestResponse>> => {
   
    const route = injectCustomIdParameter(apiRoutes.serviceConfiguration.data.deployedPolicyComponentWithId, body.id, POLICY_COMPONENT_ID_PATTERN);
    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};